import {
  GOOGLE_ADS_CAMPAIGN_STATUS,
  GoogleAdsCampaignConnectionStatus,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Google Ads',
  search: {
    placeholder: 'Buscar por ID, nombre o empresa',
  },
  filters: {
    connection_statuses: {
      placeholder: 'Estado de conexión',
      options: {
        [GoogleAdsCampaignConnectionStatus.Connected]: 'Conectado',
        [GoogleAdsCampaignConnectionStatus.NotConnected]: 'No conectado',
      },
    },
  },
  columns: {
    name: 'Nombre',
    company: 'Empresa',
    connected: 'Conectado',
    action: 'Acción',
    details: 'Detalles',
    address: 'Dirección',
    status: 'Estado',
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'No especificado',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Activo',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Pausado',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Desconocido',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Eliminado',
  },
};
